import { DataModel } from 'common/models/utility-models/base-model';
import {
  GridModel,
  GridPostParams,
} from 'common/models/utility-models/list-utility.model';

export class BucketModel extends DataModel {}

export class BucketGridParams extends GridPostParams {
  statusFlag: number = 0;
  id: any = [21, 22, 20, 23];
}

export class BucketGridModel extends BucketModel {}

export class BucketListingModel extends GridModel<BucketGridModel> {}
